import List from "@mui/material/List";
import { useSelector } from "react-redux";
import constants from "../common/constants";
import { AppBar } from "@mui/material";
import BuildIcon from '@mui/icons-material/Build';
import SideBar from "rc-material-sidebar";
import SpeedIcon from "@mui/icons-material/Speed";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import StorefrontIcon from "@mui/icons-material/Storefront";
import EventNoteIcon from '@mui/icons-material/EventNote';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

const AdminSidebar = ({ open }) => {
  const { userData } = useSelector((state) => state.mainReducer);
  const { ADMIN, USER } = constants;
  const onClick = (e, item) => {
    // console.log(e, item);
  };

  // console.log("AdminSidebar userData:", userData?.role);
  const allItems = [
    {
      key: "1",
      label: "Dashboard",
      link: "/app",
      icon: <SpeedIcon sx={{ width: "34px" }} />,
      roles: [ADMIN, USER],
    },
    {
      key: "2",
      label: "Venues",
      link: "/app/venues",
      icon: <LocationOnIcon sx={{ width: "34px" }} />,
      roles: [ADMIN],
      activeChildrenPath: ["/app/add-venues"],
    },
    {
      key: "3",
      label: "Vendors",
      link: "/app/vendors",
      icon: <StorefrontIcon sx={{ width: "34px" }} />,
      roles: [ADMIN],
      activeChildrenPath: ["/app/add-vendors"],
    },
    {
      key: "costSummary",
      label: "Cost Summary",
      link: "/app/venue-planning",
      icon: <EventNoteIcon sx={{ width: "34px" }} />,
      roles: [ADMIN],
      activeChildrenPath: ["/app/venue-planning", "/app/vendor-planning", "/app/hospitality-management", "/app/transportation"],
    },
    {
      key: "5",
      label: "Tools",
      link: "/app/tools",
      icon: <BuildIcon sx={{ width: "34px" }} />,
      roles: [ADMIN],
      children: [
        {
          key: "5.1",
          label: "Suitable Venues",
          link: "/app/suitable-venues",
          activeChildrenPath: ["/app/suitable-venues"],
        },
        // {
        //   key: "5.2",
        //   label: "Transportation",
        //   link: "/app/transportation",
        //   activeChildrenPath: ["/app/transportation"],
        // },
        // {
        //   key: "5.3",
        //   label: "Vendor Planning",
        //   link: "/app/vendor-planning",
        //   activeChildrenPath: ["/app/vendor-planning"],
        // },
        // {
        //   key: "5.4",
        //   label: "Hospitality & Management",
        //   link: "/app/hospitality-management",
        //   activeChildrenPath: ["/app/hospitality-management"],
        // },
        {
          key: "5.2",
          label: "Compare Venues",
          link: "/app/compare-venues",
          activeChildrenPath: ["/app/compare-venues"],
        },
        // {
        //   key: "5.6",
        //   label: "Venue Planning",
        //   link: "/app/venue-planning",
        //   activeChildrenPath: ["/app/venue-planning"],
        // },
      ],
    },
    // {
    //   key: "6",
    //   label: "CRM",
    //   link: "/app/crm",
    //   icon: <PersonAddIcon sx={{ width: "34px" }} />,
    //   roles: [ADMIN],
    //   activeChildrenPath: ["/app/addCRM"],
    // },
    {
      key: "6",
      label: "CRM",
      link: "/app/crm-new",
      icon: <PersonAddIcon sx={{ width: "34px" }} />,
      roles: [ADMIN],
      activeChildrenPath: ["/app/addLeads", "/app/crm-new/estimates", "/app/crm-new/addEstimate", "/app/attendees", "/app/addAttendees"],
    },
  ];

  const filteredItems = allItems.filter((item) =>
    item.roles.includes(userData?.role)
  );

  return (
    <AppBar
      position="fixed"
      component="div"
      color="transparent"
      elevation={0}
      sx={{
        width: open ? 240 : 66,
        right: "inherit",
        height: "calc(100% - 64px)",
        top: 64,
      }}
    >
      <List className="sidebarMenu">
        <SideBar
          items={filteredItems}
          variant={open ? "full" : "mini"}
          onClick={onClick}
        />
      </List>
    </AppBar>
  );
};

export default AdminSidebar;
